import { Button, CenterPopup, Image, Modal, Selector, Toast } from 'antd-mobile';
import { CheckCircleOutline } from 'antd-mobile-icons';
import { useThrottledHandler } from 'App';
import { default as Img, default as img } from 'app/img';
import axios from 'axios';
import { useI18n } from 'i18n/useI18n';
import { Label } from 'pages/webapp/page_one/mine/center';
import { useEffect, useRef, useState } from 'react';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import payApi from 'services/apis/pay/pay-api';
import { UserDataType, UserPolyInfoDT } from 'services/apis/sys/user-api';
import { UserGroupDataType } from 'services/apis/usr/user-group-api';
import { default as hexToRgb, default as hexToRgbJoin } from 'utils/colorUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import sleep from 'utils/threadUtil';
import styles from './index.module.scss';

export type LevelInfoDT = {
  userGroup: UserGroupDataType;
  selectUsergroup: (usergroup: UserGroupDataType) => void;
};

const LevelInfo = (props: LevelInfoDT) => {
  const { t } = useI18n();
  const [, _refreshView] = useState('');
  const Label = (img: string, tip: string) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'align',
          margin: 5,
        }}
      >
        <Image
          src={img}
          width={120}
          height={40}
        />
      </div>
    );
  };
  const options = [
    // {
    //   label: Label("assets/img/icon-bitcoin.ico", "Coinbase"),
    //   value: "coinbase",
    //   description: "2% off",
    // },
    // {
    //   label: Label("assets/img/icon-stripe.png", "Stripe"),
    //   value: "stripe",
    //   disabled: true,
    //   description: "suspension",
    // },
    {
      label: Label(img.alipay_logo, '支付宝'),
      value: 'alipay',
      disabled: false,
      description: <div className=" text-slate-600">* 免通道费</div>,
    },
    {
      label: Label(img.wechatpay_logo, '微信支付'),
      value: 'wxpay',
      disabled: false,
      description: <div className=" text-slate-600">* 免通道费</div>,
    },
  ];
  const coinbaseLink = [
    'https://commerce.coinbase.com/checkout/c4425d9e-ce49-4142-b552-b0811b535493',
    'https://commerce.coinbase.com/checkout/c7f7a84d-1a39-4ead-97bb-23bcc5442981',
    'https://commerce.coinbase.com/checkout/1010786e-9746-41e6-a6ce-9444cffc729a',
  ];
  const nowCoinbaseLink = coinbaseLink[props.userGroup.groupLevel - 1];

  const payAppListRef = useRef<string[]>();

  return (
    <>
      {/* 用户组标签 */}
      <div
        style={{
          background: `RGBA(${hexToRgbJoin(props.userGroup.groupBgcolor)}, 0.95)`,
        }}
        className={[' rounded-xl my-2 p-1 flex justify-between text-slate-100 bg-opacity-30 gap-2'].join(' ')}
      >
        {/* 价格 */}
        <div className=" grow flex flex-col justify-center items-center gap-3 text-nowrap ">
          {/* 价格标签 */}
          <div className=" flex flex-col justify-center items-center">
            {/* 会员级别 */}
            <div className=" text-base">{props.userGroup.groupName}</div>
            <div className=" flex justify-center items-center text-nowrap">
              <div className=" text-base">{props.userGroup.discountPrice + '￥'}</div>
              <del
                style={{ margin: 2, whiteSpace: 'nowrap' }}
                className=" flex justify-center items-center gap-2 text-xs"
              >
                <div>{t('level-info.index.180777-3')}</div>
                <div>{props.userGroup.originalPrice}</div>
              </del>
            </div>
          </div>
          {/* 开通 */}
          <div className=" flex items-center justify-center">
            <div
              className=" flex items-center justify-center p-2 gap-1 flex-nowrap text-nowrap bg-white w-28 rounded-xl"
              onClick={useThrottledHandler(() => {
                window.scrollTo({ top: 300, behavior: 'smooth' });
                props.selectUsergroup(props.userGroup);
                // fetchPayApp();
              })}
            >
              <span style={{ fontSize: 14, marginTop: 0 }}>💎</span>
              <span
                style={{
                  fontSize: 14,
                  color: props.userGroup.groupBgcolor,
                  fontWeight: 700,
                }}
              >
                立即开通
              </span>
            </div>
          </div>
        </div>

        {/* 描述 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'start',
            borderLeft: '1px dashed #fff',
            flexGrow: 1,
          }}
          className={[
            ' text-xs p-2  ',
            'bg-clip-text text-transparent bg-gradient-to-br from-white via-white to-white/70',
          ].join(' ')}
        >
          <div className=" relative text-center w-full my-1">
            <span className=" text-white">{' ' + t('level-info.index.180777-14')}</span>
            <div className=" rounded-[50px] bg-white w-3.5 h-3.5 absolute top-0 right-1"></div>
          </div>
          {props?.userGroup?.groupDesc?.map((item) => (
            <div
              key={item}
              className=" m-0.5 text-center text-nowrap flex justify-start items-center"
            >
              <CheckCircleOutline
                fontSize={14}
                style={{ margin: 1 }}
                color="white"
              />
              <span style={{ marginLeft: 5, textAlign: 'left' }}>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default LevelInfo;
